import React from 'react';

import { setLanguage } from '../../utils/i18-next';
import { changeLanguage, isValidLanguage } from '../../utils/text/translation';

/**
 * If the current URL has a `?lang=<code>` query parameter with a supported language,
 * apply it as the active Portal language on mount.
 *
 * Mirrors the two-step switch done by `useLanguage`: updates the Google Translate
 * widget (until it is removed) and changes the i18next language.
 */
export const useApplyLangFromUrl = () => {
  React.useEffect(() => {
    const lang = new URLSearchParams(window.location.search).get('lang');
    if (!lang) {
      return;
    }

    const target = isValidLanguage(lang) ? lang : 'en';
    changeLanguage(target);
    void setLanguage(target);
  }, []);
};
